import { ApiVersions } from '../api-versions';

export const apiVersion = ApiVersions.Beta;
